import { ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef, Input, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AutenticacionService } from 'src/app/services/autenticacion.service';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { MenuService } from '../../services/menu.service';


@Component({
  selector: 'componenteprincipal',
  templateUrl: './componenteprincipal.component.html',
  styleUrls: ['./componenteprincipal.component.scss']
})
export class ComponenteprincipalComponent implements OnInit{
  private creoPrimerComponente: boolean = false;

  public _Componente: any;
  @Input() set Componente(value: any) 
    {
      this._Componente = value;
      this.CambiarComponenteDinamico();
    }
  get Componente(): any 
    {
      return this._Componente;
    }

  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public autenticacionService: AutenticacionService,
    private _Resolver: ComponentFactoryResolver,
    private ViewContainer: ViewContainerRef) {}

  ngOnInit() {
    // console.log('ComponentePrincipal');
  }

  public CambiarComponenteDinamico() {
    // console.log('CambiarComponenteDinamico');
    if (this.creoPrimerComponente) {
      this.ViewContainer.clear();
    }
    const factory = this._Resolver.resolveComponentFactory(this._Componente);
    const Componente : ComponentRef<any> = this.ViewContainer.createComponent(factory);
    this.cd.detectChanges();
    this.creoPrimerComponente = true;
  }
  public VerificarComponenteDinamico(componente: any) {
    if (componente !== this.Componente) {
      this.Componente = componente;
    }
  }
}
